/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getFeatureFlags } from "api/services/common";
import { GetFeatureFlagsResponseType } from "api/response";
import { getCargobaseAuthToken } from "helpers/getAuthToken";
import { commonQueryKeys } from "./commonQueryKeys";

export function useGetFeatureFlags(options?: UseQueryOptions<GetFeatureFlagsResponseType>) {
  const hasCargobaseAuthToken = Boolean(getCargobaseAuthToken());

  return useQuery({
    queryKey: commonQueryKeys.featureFlags,
    queryFn: () => getFeatureFlags().then((res) => res.data),
    ...options,
    enabled: hasCargobaseAuthToken && (options?.enabled ?? true),
  });
}
